import { supabase } from '@/lib/supabase';
import { formatInAccountTz } from '@/lib/accountTimezone';

export function formatCrmInteractionDateTime(date = new Date()): string {
  return formatInAccountTz(date, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export async function getPipelineStageNames(
  stageIds: Array<string | null | undefined>
): Promise<Map<string, string>> {
  const ids = [...new Set(stageIds.filter((id): id is string => Boolean(id)))];
  if (!supabase || ids.length === 0) return new Map();

  const { data, error } = await supabase
    .from('account_pipeline_stages')
    .select('id, name')
    .in('id', ids);

  if (error) {
    console.error('[crmInteractionLog] Erro ao buscar etapas:', error);
    return new Map();
  }

  return new Map((data || []).map((stage) => [stage.id, stage.name]));
}

export async function logCrmContactInteraction(params: {
  accountId: string;
  contactId?: string | null;
  title: string;
  description: string;
}): Promise<void> {
  if (!supabase || !params.contactId) return;

  const { error } = await supabase.from('account_contact_interactions').insert({
    account_id: params.accountId,
    contact_id: params.contactId,
    title: params.title,
    description: params.description,
  });

  if (error) {
    console.error('[crmInteractionLog] Erro ao salvar interação:', error);
  }
}
